export default function CloudIconImpactPill() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_18122_73108"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          width="16"
          height="16"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_18122_73108)">
        <path
          d="M4.33268 13.3307C3.31046 13.3307 2.44379 12.9752 1.73268 12.2641C1.02157 11.553 0.666016 10.6863 0.666016 9.66406C0.666016 8.7974 0.93546 8.03351 1.47435 7.3724C2.01324 6.71128 2.68824 6.28628 3.49935 6.0974C3.77713 5.0974 4.32713 4.27517 5.14935 3.63073C5.97157 2.98628 6.92157 2.66406 7.99935 2.66406C9.32157 2.66406 10.4299 3.1224 11.3243 4.03906C12.2188 4.95573 12.666 6.05295 12.666 7.33073C13.4993 7.41962 14.1521 7.76406 14.6243 8.36406C15.0966 8.96406 15.3327 9.61406 15.3327 10.3141C15.3327 11.1474 15.041 11.8585 14.4577 12.4474C13.8743 13.0363 13.166 13.3307 12.3327 13.3307H4.33268ZM4.33268 11.9974H12.3327C12.7993 11.9974 13.1938 11.8363 13.516 11.5141C13.8382 11.1918 13.9993 10.7974 13.9993 10.3307C13.9993 9.86406 13.8382 9.46962 13.516 9.1474C13.1938 8.82517 12.7993 8.66406 12.3327 8.66406H11.3327V7.33073C11.3327 6.40851 11.0077 5.6224 10.3577 4.9724C9.70768 4.3224 8.92157 3.9974 7.99935 3.9974C7.29935 3.9974 6.67713 4.18906 6.13268 4.5724C5.58824 4.95573 5.18824 5.4474 4.93268 6.0474C5.79935 6.19184 6.52713 6.60017 7.11602 7.2724C7.7049 7.94462 7.99935 8.74184 7.99935 9.66406H6.66602C6.66602 9.01962 6.43824 8.46962 5.98268 8.01406C5.52713 7.55851 4.97713 7.33073 4.33268 7.33073C3.68824 7.33073 3.13824 7.55851 2.68268 8.01406C2.22713 8.46962 1.99935 9.01962 1.99935 9.66406C1.99935 10.3085 2.22713 10.8585 2.68268 11.3141C3.13824 11.7696 3.68824 11.9974 4.33268 11.9974Z"
          fill="#BFBFBF"
        />
      </g>
    </svg>
  );
}
